import axios from 'axios';
import Cookies from 'universal-cookie';
import decode, { JwtPayload } from 'jwt-decode';
import constants from '../constants';

interface CustomJwtPayload extends JwtPayload {
  userId?: string;
  adminId?: string;
}

export default class AuthService {
  private cookies: Cookies;

  constructor() {
    this.cookies = new Cookies();
  }

  async createSession() {
    const currentCustomerNumber = this.getCurrentCustomerNumber() ? this.getCurrentCustomerNumber() : '';

    return await axios
      .get(`${constants.ONTRAQ_API_URL}/api2/session/create-session/${currentCustomerNumber}`)
      .then((res) => {
        const userData = res.data;
        this.setCurrentUser(userData);

        if (!currentCustomerNumber) {
          this.setCurrentCustomerNumber(userData.customer_number);
        }

        return userData;
      })
      .catch((error) => {
        console.error(error);
        return false;
      });
  }

  clearSession() {
    this.cookies.remove('currentCustomerNumber', { path: '/' });
    this.cookies.remove('jwtToken', { path: '/' });
    localStorage.clear();
  }

  getCurrentCustomerNumber() {
    return this.cookies.get('currentCustomerNumber');
  }

  getCurrentUser() {
    const user = localStorage.getItem('currentUser');
    return user ? JSON.parse(user) : null;
  }

  getDEToken() {
    return localStorage.getItem('deToken');
  }

  getLoginUrl(uri: string) {
    return constants.LOGIN_URL + uri;
  }

  getToken() {
    return this.cookies.get('jwtToken');
  }

  getUserId() {
    const token = this.getToken();
    if (!token) return null;
    const decoded = decode<CustomJwtPayload>(token);
    return decoded.userId;
  }

  getAdminId() {
    return this.cookies.get('adminId');
  }

  isTokenExpired(token: string | null) {
    if (!token) return true;
    const decoded = decode<CustomJwtPayload>(token);
    if (!decoded?.exp || decoded.exp < Date.now() / 1000) {
      this.logout();
      return true;
    }
    return false;
  }

  async loggedIn() {
    const token = this.getToken();
    const loggedIn = !!token && !this.isTokenExpired(token);

    if (!loggedIn) {
      return this.redirectToLogin();
    }
    return true;
  }

  logout() {
    this.clearSession();
    this.redirectToLogin();
  }

  redirectToLogin() {
    const redirectUrl = encodeURIComponent(window.location.href);

    if (redirectUrl.includes('logout')) {
      window.location.href = this.getLoginUrl(`/logout?service=ontraq`);
      return;
    }

    const loginUrl = encodeURIComponent(this.getLoginUrl(`/?service=ontraq&redirectUrl=${redirectUrl}`));
    window.location.href = this.getLoginUrl(`/logout?service=ontraq&redirectUrl=${loginUrl}`);
  }

  setCurrentCustomerNumber(customerNumber: string) {
    this.cookies.set('currentCustomerNumber', customerNumber, { path: '/' });
  }

  setCurrentUser(user: any) {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  setAccessToken(accessToken: string) {
    this.cookies.set('jwtToken', accessToken, { path: '/' });
  }

  setDEToken(token: string) {
    localStorage.setItem('deToken', token);
  }
}
